// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1YLfe","productName":"Table_productName__1073v"};